const WEEKDAY_MONTH_DAY = new Intl.DateTimeFormat('en-US', {
  weekday: 'short',
  month: 'long',
  day: 'numeric',
});
const TIME = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});

// "Sun, August 3 \u00b7 5:30 PM" \u2014 what moment produced for
// 'ddd, MMMM D [\u00b7] h:mm A', without shipping moment and its locales.
// Empty for a missing or unparseable date: Intl throws on an Invalid Date
// where moment printed the string "Invalid date", and neither belongs on
// screen \u2014 a finished meeting arrives with no appointment_start at all.
export function formatDate(date: string | null | undefined) {
  if (!date) {
    return '';
  }
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) {
    return '';
  }
  return `${WEEKDAY_MONTH_DAY.format(parsed)} \u00b7 ${TIME.format(parsed)}`;
}
